import { isAfter } from "date-fns";
import format from "date-fns/format";
import ptBR from "date-fns/locale/pt-BR";

export function hasHTMLTag(value: string) {
  return /<\/?[a-z][\s\S]*>/.test(value);
}

export function getDate() {
  return format(new Date(), "dd/MM/yyyy", {
    locale: ptBR,
  });
}

export function getDateISOBegin(value: Date) {
  // return value.toISOString().split('T')[0] + 'T00:00:00.000Z'
  return value.toISOString();
}

export function getDateISOEnd(value: Date) {
  // return value.toISOString().split('T')[0] + 'T23:59:59.000Z'
  return value.toISOString();
}

export function convertDateTimeISOWithTimeZone(value: Date) {
  return new Date(
    value.getTime() - value.getTimezoneOffset() * 60000
  ).toISOString();
}

export function convertDateTimeISOWithTimeZoneEND(value: Date) {
  return new Date(
    value.getTime() + 59999 - value.getTimezoneOffset() * 60000
  ).toISOString();
}

export function convertDate(value: string) {
  const newDate = value ? new Date(value) : new Date().getDate();
  return format(newDate, "dd/MM/yyyy", {
    locale: ptBR,
  });
}

export function convertTime(value: string) {
  const newDate = value ? new Date(value) : new Date().getTime();

  return format(newDate, "pp", {
    locale: ptBR,
  });
}

export function convertDateAndTime_OLD(value: string) {
  let newDate = value ? new Date(value) : new Date();
  const date = format(newDate, "dd/MM/yyyy", {
    locale: ptBR,
  });
  const time = format(newDate, "pp", {
    locale: ptBR,
  });

  return `${date} ${time}`;
}

export function convertDateAndTime(value: string) {
  if (!value || value.length === 0 || value === "0000-00-00T00:00:00.000Z")
    return "-";
  const date = value.split("T");
  const dateToFormat = date[0].split("-");
  const string = `${dateToFormat[2]}/${dateToFormat[1]}/${dateToFormat[0]}`;
  const hours = date[1].split(".")[0];

  return string + " " + hours;
}

export function convertChartDetailsDataToArray(value: string) {
  return JSON.parse("[" + value + "]");
}

export function concatArray(array: any, key: string) {
  const newArray = array.map((element: any) => element[key]);
  return newArray.join(", ");
}

export function concatArrayAndFormatData(
  array: any,
  key: string,
  func: Function
) {
  const newArray = array.map((element: any) => func(element[key]));
  return newArray.join(", ");
}

export function phoneWithMask(value: string) {
  const phone = value.slice(2);
  const output1 = [phone.slice(0, 0), "(", phone.slice(0)].join("");
  const output2 = [output1.slice(0, 3), ") ", output1.slice(3)].join("");
  const phoneWithMask = [output2.slice(0, 10), "-", output2.slice(10)].join("");
  return phoneWithMask;
}

export function formatPhone(value: string) {
  let phone = value.replace(/\D/g, "");
  if (phone.split("")[0] === "5") {
    phone = phone.slice(2);
  }
  const output1 = [phone.slice(0, 0), "(", phone.slice(0)].join("");
  const output2 = [output1.slice(0, 3), ") ", output1.slice(3)].join("");
  const phoneWithMask = [output2.slice(0, 10), "-", output2.slice(10)].join("");
  return phoneWithMask;
}

export function phoneWithoutDDI(value: string) {
  return value.slice(2);
}

export function phoneRemoveCharacters(value: string) {
  const filter1 = value.replace(/\(/g, "");
  const filter2 = filter1.replace(/\)/g, "");
  const filter3 = filter2.replace(/-/g, "");
  const newValue = filter3.replace(" ", "");
  return newValue;
}

export function isAfterDate(date1: Date, date2: Date) {
  return isAfter(date1, date2);
}

export function capitalized(word: string) {
  return word.replace(/^\w/, (c) => c.toUpperCase());
}
export function normalizedText(text: string) {
  return text?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function isValidCNPJ(value: string) {
  const cnpj = value.replace(/[^\d]+/g, "");

  if (cnpj === "" || cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros: string = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma = soma + Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) return false;

  return true;
}

export function isValidCPF(cpf: string) {
  if (cpf === null || cpf.length !== 11) {
    return false;
  }

  if (
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return false;
  }
  let numero: number = 0;
  let caracter: string = "";
  let numeros: string = "0123456789";
  let j: number = 10;
  let somatorio: number = 0;
  let resto: number = 0;
  let digito1: number = 0;
  let digito2: number = 0;
  let cpfAux: string = "";
  cpfAux = cpf.substring(0, 9);
  for (let i: number = 0; i < 9; i++) {
    caracter = cpfAux.charAt(i);
    if (numeros.search(caracter) === -1) {
      return false;
    }
    numero = Number(caracter);
    somatorio = somatorio + numero * j;
    j--;
  }
  resto = somatorio % 11;
  digito1 = 11 - resto;
  if (digito1 > 9) {
    digito1 = 0;
  }
  j = 11;
  somatorio = 0;
  cpfAux = cpfAux + digito1;
  for (let i: number = 0; i < 10; i++) {
    caracter = cpfAux.charAt(i);
    numero = Number(caracter);
    somatorio = somatorio + numero * j;
    j--;
  }
  resto = somatorio % 11;
  digito2 = 11 - resto;
  if (digito2 > 9) {
    digito2 = 0;
  }
  cpfAux = cpfAux + digito2;
  if (cpf !== cpfAux) {
    return false;
  } else {
    return true;
  }
}

export function getUserLanguage(lang: string) {
  switch (lang) {
    case "pt-BR":
      return "PORTUGUÊS";
    case "en-US":
      return "INGLÊS";
    default:
      break;
  }
}

export function passwordValidate(value: string): boolean {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])\S{6,10}$/;
  return regex.test(value);
}
